import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["clsPrefix", "type", "disabled", "onClick", "htmlType", "children", "className", "trigger", "href", "icon", "title", "buttonsRender", "size", "triggerType", "style"];

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from '../../wui-icon/src';
import Button from '../../wui-button/src';
import { WebUI } from "../../wui-core/src/index.js";
import Dropdown from './Dropdown';
var ButtonGroup = Button.Group;
var DropDownProps = Dropdown.propTypes;
export var DropdownButtonProps = _objectSpread(_objectSpread({}, DropDownProps), {}, {
  size: PropTypes.oneOf(['sm', 'md', 'xg', 'lg', 'small', 'large', 'middle']),
  style: PropTypes.object,
  className: PropTypes.string,
  clsPrefix: PropTypes.string,
  type: PropTypes.oneOf(['primary', 'ghost', 'dashed', 'default']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  icon: PropTypes.element,
  href: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string,
  // 触发下拉的类型button、icon, 默认button 类型
  triggerType: PropTypes.string,

  /**
   * @title 自定义左右两个按钮
   * @des 返回一个处理好的元素数组 (buttons: ReactNode[]) => ReactNode[]
   * @veIgnore
   */
  buttonsRender: PropTypes.func
});

var defaultProps = _objectSpread(_objectSpread({}, Dropdown.defaultProps), {}, {
  type: 'default',
  size: null,
  style: {},
  className: '',
  disabled: false,
  title: '',
  // 左侧按钮title 属性
  // href: '',
  triggerType: 'button',
  buttonsRender: function buttonsRender(buttons) {
    return buttons;
  }
});

var DropdownButton = (_dec = WebUI({
  name: "dropdown-button",
  defaultProps: defaultProps
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownButton, _React$Component);

  var _super = _createSuper(DropdownButton);

  function DropdownButton(props) {
    _classCallCheck(this, DropdownButton);

    return _super.call(this, props);
  }

  _createClass(DropdownButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          type = _this$props.type,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          htmlType = _this$props.htmlType,
          children = _this$props.children,
          className = _this$props.className,
          trigger = _this$props.trigger,
          href = _this$props.href,
          _this$props$icon = _this$props.icon,
          icon = _this$props$icon === void 0 ? /*#__PURE__*/React.createElement(Icon, {
        type: "uf-gridcaretdown"
      }) : _this$props$icon,
          title = _this$props.title,
          buttonsRender = _this$props.buttonsRender,
          size = _this$props.size,
          triggerType = _this$props.triggerType,
          style = _this$props.style,
          restProps = _objectWithoutProperties(_this$props, _excluded);

      var dropdownProps = {
        disabled: disabled,
        trigger: disabled ? [] : trigger
      };
      var leftButton = /*#__PURE__*/React.createElement(Button, {
        type: type,
        size: size,
        disabled: disabled,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
      }, children);
      var rightButton = /*#__PURE__*/React.createElement(Button, {
        size: size,
        type: type,
        icon: icon
      });

      var _buttonsRender = buttonsRender([leftButton, rightButton]),
          _buttonsRender2 = _slicedToArray(_buttonsRender, 2),
          leftButtonToRender = _buttonsRender2[0],
          rightButtonToRender = _buttonsRender2[1];

      if (triggerType === 'button') {
        return /*#__PURE__*/React.createElement(Dropdown, _extends({}, dropdownProps, restProps), /*#__PURE__*/React.cloneElement(leftButtonToRender, {
          icon: icon,
          style: style,
          className: classNames(clsPrefix, className, "".concat(clsPrefix, "-no-line"))
        }));
      }

      return /*#__PURE__*/React.createElement(ButtonGroup, {
        style: style,
        className: classNames(clsPrefix, className)
      }, leftButtonToRender, /*#__PURE__*/React.createElement(Dropdown, _extends({}, dropdownProps, restProps), rightButtonToRender));
    }
  }]);

  return DropdownButton;
}(React.Component), _defineProperty(_class2, "propTypes", DropdownButtonProps), _temp)) || _class);
;
export default DropdownButton;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-dropdown/src/DropdownButton.js